import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';

/** An eye surrounded by directional flow nodes: architecture observed in both directions. */
export const ArchitectureObservabilityIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ color = 'currentColor', size = 24, strokeWidth = 2, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M3 12s3.2-4.5 9-4.5 9 4.5 9 4.5-3.2 4.5-9 4.5S3 12 3 12Z" />
      <circle cx="12" cy="12" r="2.6" />
      <path d="M12 5.5V2.5m0 0-1.4 1.4M12 2.5l1.4 1.4M5.9 7.3 4 5.4m0 0v1.8m0-1.8h1.8M18.1 7.3 20 5.4m0 0v1.8m0-1.8h-1.8M5.9 16.7 4 18.6m0 0v-1.8m0 1.8h1.8M18.1 16.7l1.9 1.9m0 0v-1.8m0 1.8h-1.8M12 18.5v3m0 0-1.4-1.4m1.4 1.4 1.4-1.4" />
      <circle cx="4" cy="5.4" r=".7" fill={color} stroke="none" />
      <circle cx="20" cy="5.4" r=".7" fill={color} stroke="none" />
      <circle cx="4" cy="18.6" r=".7" fill={color} stroke="none" />
      <circle cx="20" cy="18.6" r=".7" fill={color} stroke="none" />
    </svg>
  )
);

ArchitectureObservabilityIcon.displayName = 'ArchitectureObservabilityIcon';
